import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import handleAsyncThunk from "../handleAsyncThunk";
import authApi from "../../services/authApi";
import { storage } from "../../config/storage";

export const fetchUniversityDetails = createAsyncThunk(
    "university/fetchDetails",
async (data) => {
      // TODO: do some more refining
      const universityId = storage.fetchFromLocalStorage.universityId()
      if(universityId && universityId !== "undefined") {
        return universityId
      }else {
        const { subDomain } = data;
    
        const requestData = {
            subDomain
        };
    
        // Call the API to send user activity
        const response = await authApi.getUniversityDetails(requestData);
        const universityId = response.data?.university?._id;

        storage.setInLocalStorage.universityId(universityId);
        return universityId;
    }
});

const universitySlice = createSlice({
    name: "university",
    initialState: {
      universityId: null,
    },
    extraReducers: (builder) => {
        handleAsyncThunk(builder, fetchUniversityDetails, "universityId"); // Use builder notation
    },
});

export default universitySlice.reducer